import React, { createContext, useState, useEffect } from "react";
import useFetch from "../../hooks/useFetch";

export const UsersContext = createContext();
UsersContext.displayName = "User Data Context";

export const UsersContextProvider = (props) => {
  const [currentUser, setCurrentUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingUsers, setisLoadingUsers] = useState(true);
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [latestQuery, setLatestQuery] = useState({});
  const [users, setUsers] = useState([]);
  const { get } = useFetch();

  useEffect(() => {
    getCurrentUser();
  }, []);

  const getCurrentUser = (token = null) => {
    setIsLoading(true);
    return new Promise((resolve, reject) => {
      get("/session", token)
        .then((res) => {
          setCurrentUser(res);
          setIsLoading(false);
          resolve(true);
        })
        .catch((e) => {
          setIsLoading(false);
          reject(e);
        });
    });
  };

  const getUsers = async (queries = {}) => {
    setisLoadingUsers(true);
    setLatestQuery(queries);
    let url = "/users?";

    Object.keys(queries).forEach(function (key) {
      url += key + "=" + queries[key] + "&";
    });

    get(url)
      .then((res) => {
        setUsers(res.users);
        setMaxPagination(res.total);
        setCurrentPage(Number(res.page));
        setisLoadingUsers(false);
      })
      .catch((e) => {
        console.log(e);
        throw new Error(e);
      });
  };

  const setPagination = (page) => {
    let newQuery = { ...latestQuery };
    newQuery.page = page;
    getUsers(newQuery);
  };

  const getPriceLists = async () => {
    return new Promise((resolve, reject) => {
      get("/users/price-lists")
        .then((res) => {
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const getZones = async () => {
    return new Promise((resolve, reject) => {
      get("/users/zones")
        .then((res) => {
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  return (
    <UsersContext.Provider
      value={{
        users,
        currentUser,
        getCurrentUser,
        isLoadingUser: isLoading,
        isLoadingUsers,
        getUsers,
        setPagination,
        maxPagination,
        currentPage,
        getPriceLists,
        getZones,
      }}
    >
      {props.children}
    </UsersContext.Provider>
  );
};
